import { type AssertFn, crashReporterInterface, localPreferences, tracker } from 'app-components/utils/core';
import { getAssertDetails } from 'app-components/utils/core/axiosErrorGrouping';
import { describeValue } from 'app-components/utils/core/telemetrySafe';

// verify (dev mode) - checks value and if value=false then log the message + popup alert; returns value back!
// verify (release mode) - checks value and if value=false then log the message; returns value back!
// assert (dev mode) - checks value and if value=false then log the message + popup alert + track assert; returns value back!
// assert (release mode) - checks value and if value=false then log the message + track assert; returns value back!

import sprintfDefault from 'sprintf-js';
const { sprintf } = sprintfDefault;

const getDescription = (messageOrException: unknown, ...substitutions: unknown[]): string => {
  let description: string;

  if (typeof messageOrException === 'string') {
    if (substitutions?.length) {
      description = sprintf(messageOrException, ...substitutions);
    } else {
      description = messageOrException;
    }
  } else {
    description = describeValue(messageOrException);
  }

  return description;
};

export const verify: AssertFn = (assertion, messageOrException, ...substitutions) => {
  if (!assertion) {
    // biome-ignore lint/suspicious/noConsole: reporting a failed assertion is the point of this function
    console.assert(false, messageOrException, ...substitutions);

    const description = getDescription(messageOrException, ...substitutions);
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const suppressAssertPopups = localPreferences.getSuppressAssertPopups();
    if (!suppressAssertPopups) {
      const object = messageOrException === description ? substitutions?.[0] : undefined;
      if (
        !window.confirm(
          `OK - ignore\
      \nCancel - abort/debug execution\
      \nUse 'dev menu > Crash > Suppress Asserts' to disable popups\
      \n\nassertion: ${description} ${object ? JSON.stringify(object, null, 2) : ''}`,
        )
      ) {
        // biome-ignore lint/suspicious/noDebugger: stops here when a developer chooses to debug a failed assert
        debugger;
        // nodeAssert(assertion, description);
        return true;
      }
    }
/////////////

    tracker.track(tracker.events.assert, { description });
  }
  return assertion;
};

export const assert: AssertFn = (assertion, messageOrException, ...substitutions) => {
  const result = verify(assertion, messageOrException, ...substitutions);

  if (!result) {
    const description = getDescription(messageOrException, ...substitutions);
    const error = new Error(description);
    error.name = 'Assert';
    const object = messageOrException === description ? substitutions?.[0] : messageOrException;
    if (object instanceof Error && object.stack) {
      error.stack = object.stack; // use original error stack
    }
    crashReporterInterface.reportError(error, getAssertDetails([messageOrException, ...substitutions]), {
      context: error.message,
    });
  }

  return result;
};

if (typeof self === 'object') {
  self.assert = assert;
  self.verify = verify;
}
